import { api } from './api';
import {Wallet, WalletTransaction} from "../types/Wallet";

// Fetch paginated wallet transactions for a user
export const getWalletTransactions = (
    page: number = 1,
    limit: number = 20,
    filters: { driverUid?: string; riderUid?: string } = {}
) =>
    api.get<{ data: WalletTransaction[]; page: number; total: number; limit: number; totalPages: number }>(
        '/admin/wallet/transactions',
        {
            params: {
                page,
                limit,
                ...filters,
            }
        }
    );

// Fetch wallet details for a user
export const getWallet = (
    filters: { driverUid?: string; riderUid?: string } = {}
) =>
    api.get<{ data: Wallet }>(
        '/admin/wallet',
        {
            params: {
                ...filters,
            }
        }
    );

// Fetch single transaction details
export const getWalletTransaction = (transactionId: number) =>
    api.get(`/admin/wallet/transaction/${transactionId}`);
